module.exports = __webpack_public_path__ + "static/media/galeryDoors1.c3a1e10c.jpg";